import React, { FC, useMemo, useState } from 'react'
import * as S from './styles'
import { CustomSearchField } from 'components/CustomSearchField'

type Option = {
  id: number | string
  name: string
}

interface PlanInfoGroupSelectProps {
  options: Option[]
  selectedId?: string | number | null
  onSelect: (id: string | number) => void
  label?: string
  description?: string
  inputPlaceholder?: string
  floatingLabel?: string
  emptyOptionsMessage?: string
}

export const PlanInfoGroupSelect: FC<PlanInfoGroupSelectProps> = ({
  options,
  selectedId,
  onSelect,
  label = '',
  description,
  inputPlaceholder = 'Digite para buscar e selecione',
  floatingLabel = 'Digite para buscar e selecione',
  emptyOptionsMessage = 'Nenhum resultado. Verifique sua digitação.',
}) => {
  const [search, setSearch] = useState('')

  const selectedOption = useMemo(() => {
    if (selectedId === null || selectedId === undefined) return []
    const found = options.find((op) => op.id === selectedId)
    return found ? [found] : []
  }, [options, selectedId])

  const filteredOptions = useMemo(() => {
    if (!search) return options
    const term = search.toLowerCase()
    return options.filter((op) => op.name.toLowerCase().includes(term))
  }, [options, search])

  function handleChange(value: string) {
    setSearch(value)
  }

  function handleClear() {
    setSearch('')
    onSelect(null)
  }

  function handleSelectOption(id: number | string) {
    onSelect(id)
  }

  return (
    <S.PlanInfoGroupSelectContainer>
      <CustomSearchField
        id='signup-plan-type'
        label={label}
        description={description}
        options={filteredOptions}
        selectedOptions={selectedOption}
        emptyOptionsMessage={emptyOptionsMessage}
        inputPlaceholder={inputPlaceholder}
        floatingLabel={floatingLabel}
        value={search}
        onChange={handleChange}
        onSelectOption={handleSelectOption}
        clearSearchField={handleClear}
        next={() => undefined}
        hasMore={false}
        closeOnSelect
      />
    </S.PlanInfoGroupSelectContainer>
  )
}

export default PlanInfoGroupSelect


